import client from './client';

export interface HealthResponse {
  status: string;
}

export const getHealth = async (): Promise<HealthResponse> => {
  const res = await client.get('/health');
  return res.data;
};
